import { Component, OnInit } from '@angular/core';
import { LoginComponent } from './login.component';
import { APP_CONFIG } from '@core-app/app.config';

@Component({
    selector: 'core-activate',
    templateUrl: './activate.component.html',
    standalone: false,
})
export class ActivateComponent extends LoginComponent implements OnInit {
    token: string | null = null;

    override ngOnInit() {
        super.ngOnInit();
        this.loading = false;
        this.errorMessage = false;
        this.successMessage = false;
        this.loginType = 'activate';

        this.titleService.setTitle('Activate - ' + APP_CONFIG.appName);

        this.subscriptions.push(
            this.route.paramMap.subscribe(params => {
                this.token = params.get('token');
            }),
        );
    }

    activate() {
        if (!this.token) {
            this.errorMessage = 'Invalid activation token.';
            return;
        }

        this.loading = true;
        this.errorMessage = false;
        this.successMessage = false;

        this.subscriptions.push(
            this.api.post('activate', { token: this.token }).subscribe(
                () => {
                    this.loading = false;
                    this.token = null;
                    this.successMessage = 'You\'ve activated your account and can now <a href="/login">sign in</a>.';
                },
                () => {
                    this.loading = false;
                    this.errorMessage =
                        'Activation failed, please try <a href="/register">registering your account</a> again.';
                },
            ),
        );
    }
}
